import { z } from "zod";

export type IVisibilitySource = z.infer<typeof TVisibilitySource>;
export const TVisibilitySource = z.enum([
  "landlord",
  "landlordAdmin",
  "tenant",
  "tenantAdmin",
  "entrepreneur",
]);
